import {
  parseISO,
  startOfDay,
  isSameDay,
  addDays,
  differenceInDays,
  format
} from "date-fns";

// ✅ Conversion robuste (string | Date | null)
export const toDate = (value) => {
  if (!value) return null;

  let date;

  if (value instanceof Date) {
    date = value;
  } else if (typeof value === "string") {
    date = parseISO(value);
  } else {
    date = new Date(value);
  }

  return startOfDay(date);
};

// ✅ Aujourd’hui
export const today = () => startOfDay(new Date());

// ✅ Demain
export const tomorrow = () => addDays(today(), 1);

// ✅ Comparaison jour
export const isSame = (d1, d2) => {
  if (!d1 || !d2) return false;
  return isSameDay(d1, d2);
};

// ✅ Différence en jours
export const diffDays = (d1, d2) => {
  const date1 = toDate(d1);
  const date2 = toDate(d2);

  if (!date1 || !date2) return 0;

  return differenceInDays(date1, date2);
};

// ✅ Format affichage
export const formatDate = (d) => {
  const date = toDate(d);
  if (!date) return "-";

  return format(date, "dd/MM/yyyy");
};

// ✅ Demain ?
export const isTomorrow = (d) => {
  const date = toDate(d);
  return date && isSame(date, tomorrow());
};

// ✅ Aujourd’hui ?
export const isToday = (d) => {
  const date = toDate(d);
  return date && isSame(date, today());
};

export const toInputDate = (d) => {
  const date = toDate(d);
  if (!date) return "";

  return format(date, "yyyy-MM-dd");
};